import { render } from "./PodsumowaniePoziomu.vue?vue&type=template&id=0538b742&scoped=true"
import script from "./PodsumowaniePoziomu.vue?vue&type=script&lang=js"
export * from "./PodsumowaniePoziomu.vue?vue&type=script&lang=js"

import "./PodsumowaniePoziomu.vue?vue&type=style&index=0&id=0538b742&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0538b742"]])

export default __exports__